import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AuthService } from '../_service/auth.service';
import { Router } from '@angular/router';
import { AlertifyService } from '../_service/alertify.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  forgotPasswordForm: FormGroup;
  inValidEmail: any = [];
  validEmail: any = [];
  isLoading = false;

  constructor(private authService: AuthService,
    private router: Router,
     private alertify: AlertifyService,
     public fb: FormBuilder,
     private dialog: MatDialog) { 
      this.forgotPasswordForm = fb.group({
        emailFormControl : new FormControl('', [
          Validators.required,
          this.WhitespaceValidator,
          Validators.pattern('^[a-zA-Z0-9_.+-]+[@]{1}[a-zA-Z0-9-.]+[.]{1}[a-zA-Z0-9]{2,3}$'),
        ])
      });
     }

     model: any = {};
     @Output() cancelRegister = new EventEmitter();

  ngOnInit() {
  }

  public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  forgotPassword() {
    this.isLoading = true;
    return this.authService.forgotPassword(this.model).subscribe(
      res => {
        this.inValidEmail = res.headers.get('forgotPasswordInvalid');
        this.validEmail = res.headers.get('forgotPasswordSuccess');
        if (this.inValidEmail !== null) {
          this.alertify.message(this.inValidEmail);
          this.isLoading = false;
        }
        if (this.validEmail !== null) {
          this.alertify.success(this.validEmail);
          this.isLoading = false;
          this.dialog.closeAll();
        }
      },
      error => {
        this.alertify.error('Something went wrong!');
        this.isLoading = false;
      }
    );
  }

  cancel() {
    this.cancelRegister.emit(false);
    this.router.navigate(['/login']);
  }
}